import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { BaseModel } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class EmailLogService extends BaseApiService<
	BaseModel,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const emailLogsService = new EmailLogService(URLS.USER_EMAIL_LOGS);
